import React from 'react';
import { Box, Typography, Stack, Link as MuiLink, Divider } from '@mui/material';
import { Link } from 'react-router-dom';

const FooterBottom = () => {
    const legalLinks = [
        { text: 'Privacy Policy', path: '/privacy' },
        { text: 'Terms of Service', path: '/terms' },
        { text: 'FAQ', path: '/faq' },
        { text: 'Contact Us', path: '/contact' }
    ];

    return (
        <>
            <Divider sx={{ my: 4, borderColor: 'rgba(102, 187, 106, 0.3)' }} />

            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2
            }}>
                <Typography variant="body2" sx={{
                    opacity: 0.9,
                    color: '#ffffff',
                    textAlign: { xs: 'center', sm: 'left' }
                }}>
                    © {new Date().getFullYear()} Sortify - The IUBAT Duo | Powered by AI for Environmental Change
                </Typography>

                <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
                    {legalLinks.map((link) => (
                        <MuiLink
                            key={link.text}
                            component={Link}
                            to={link.path}
                            sx={{
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                '&:hover': { color: '#66bb6a' },
                                transition: 'color 0.3s ease'
                            }}
                        >
                            {link.text}
                        </MuiLink>
                    ))}
                </Stack>
            </Box>
        </>
    );
};

export default FooterBottom;
